<template>
  <div class='section'>
    <div class='section-title'>
      <h1>VIP 의전</h1>
    </div>
    <div class='section-title-underline'></div>
    <div class='section-title-description'>
      <h2>최고의 비즈니스 의전 차량 서비스</h2>
      <div class='section-title-description-sub'>
        <p>렌트드림은 최고급 세단과 밴을 이용한 의전서비스를 제공합니다.</p>
        <p>모든 차량은 2년 미만 출고 차량이며, <br v-if='window.width < 1500'>기본적으로 와이파이, 생수 제공 등 다양한 서비스를 이용할 수 있습니다.</p>
      </div>
    </div>
    <div class='section-content'>
      <div class='vip-car-img'>
        <table v-if='window.width > 710'>
          <tr>
            <td  style='width: 423px;'>
              <img src='../assets/vip-1.png'>
            </td>
            <td style='width: 443px;'>
              <img src='../assets/s560-maybach-black.png'>
            </td>
            <td style='width: 519px;'>
              <img src='../assets/flyingspur-blue.png'>
            </td>
            <td style='width: 445px;'>
              <img src='../assets/benz-ban.png'>
            </td>
          </tr>
        </table>
        <table v-if='window.width < 710'>
          <tr>
            <td>
              <img src='../assets/vip-mobile-1.jpeg'>
            </td>
            <td>
              <img src='../assets/vip-mobile-2.jpeg'>
            </td>
          </tr>
          <tr>
            <td>
              <img src='../assets/vip-mobile-3.jpeg'>
            </td>
            <td>
              <img src='../assets/vip-mobile-4.jpeg'>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    props: ['window'],
    components: {

    },
  }
</script>

<style scoped>

  .section-title-description {
    margin-top: 12.3em;
  }

  .section-title-description-sub {
    margin-top: 2%;
  }

  .section-content {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
  }
  .section-content-img {
    margin: 2%;
  }
  .section-content-img img {
    width: 100%;
  }

  .vip-car-img {
    margin: 3% 0%;
    text-align: center;
  }
  .vip-car-img img {
    width: 100%;
  }
  .vip-car-img td{
    vertical-align: baseline;
    width: 420px;
  }


</style>
